import { DailyTradingReportFilter } from "../types";
import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

export const getDailyTradingExcel = (
  user: User,
  filter: DailyTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getdailytradingxls",
    params: {
      userid: user.userId,
      reportdate: getParamsDateString(filter.reportDate),
    },
  });
};

export default getDailyTradingExcel;
